// 定义一些常量

// 状态码
const code_status = 200

export default {
    code_status,
}